import { useState, useCallback, useEffect } from 'react';

const useKeyPress = ({ key, element, onPress, }) => {
    const [keyPressed, setKeyPressed] = useState(false);
    const downHandler = useCallback((event) => {
        if (event.key === key) {
            setKeyPressed(true);
            if (onPress) {
                onPress(event, 'KEYDOWN');
            }
        }
    }, [key, onPress]);
    const upHandler = useCallback((event) => {
        if (event.key === key) {
            setKeyPressed(false);
            if (onPress) {
                onPress(event, 'KEYUP');
            }
        }
    }, [key, onPress]);
    useEffect(() => {
        const targetElem = (element === null || element === void 0 ? void 0 : element.current) ? element.current : document;
        targetElem.addEventListener('keydown', downHandler);
        targetElem.addEventListener('keyup', upHandler);
        return () => {
            targetElem.removeEventListener('keydown', downHandler);
            targetElem.removeEventListener('keyup', upHandler);
        };
    }, [downHandler, upHandler, element]);
    return keyPressed;
};

export { useKeyPress };
//# sourceMappingURL=useKeyPress.js.map
